import React from 'react';
import ParticleBackground from './components/ParticleBackground';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import HowIWork from './components/HowIWork';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <ParticleBackground />
      <div className="site-wrapper">
        <Navbar />
        <Hero />
        <div className="section-divider" />
        <About />
        <div className="section-divider" />
        <HowIWork />
        <div className="section-divider" />
        <CaseStudies />
        <div className="section-divider" />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
